export default "__VITE_ASSET__BsYO_bI2__"